import router from '../router/index';

export default {
  install: function (Vue, options) {
   
   //调用：this.$el_alert('这是一条消息提示'); duration=0,则不会自动关闭
    Vue.prototype.$el_alert_time=function(str,duration) {
      this.$message({
		  message:str,
		  duration:duration
	  });
    }
	//调用：this.$el_alert_type('这是一条消息提示','success'); 默认时间3000毫秒
	 Vue.prototype.$el_alert_type=function(str,type) {
		 //type:success/warning/info/error    /成功消息/警告消息/普通消息/错误提示
	  this.$message({
          message: str,
          type: type
        });
	}
  }
}



// WEBPACK FOOTER //
// ./src/util/public.js